var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('layoutTopbar'),_c('el-container',{staticClass:"u-flex-col"},[_c('el-container',[_c('layoutAsideAd'),_vm._t("default")],2),_c('layoutFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }